import { API } from 'aws-amplify';
export const trackEvent = (eventName, item = {}) => {
  return new Promise((resolve, reject) => {
    API.post("API", "/profile", {
      response: false,
      body: {
        action: "event",
        name: eventName,
        item: item
      }
    }).then(response => {
      resolve(response);
    }).catch(error => {
      reject(error);
    })
  });
}